import Vue from 'vue'
import { Store } from 'vuex'
import Component from 'vue-class-component'
import RootState from '../../store/state'
import { Getters } from '../../store/editor/components/helpers'
import { GerberaContent, GerberaHeader } from '../../store/editor/components/state'
import { PreviewContentType } from './PreviewInterface'
import moment, { Moment } from 'moment'

moment.locale('ja')

@Component({
  props: {
    previewContentType: {
      type: String,
      required: false,
      default: 'internal'
    }
  }
})
export default class HeaderSectionVue extends Vue {
  $store: Store<RootState>
  readonly previewContentType?: PreviewContentType

  get contentData(): GerberaContent {
    return Getters.gerberaContent(this.$store)
  }

  get headerData(): GerberaHeader {
    return Getters.headerSectionContent(this.$store)
  }

  get color(): string | undefined {
    const header = this.headerData
    return (header && header.background) ? header.background.color : undefined
  }

  get title(): string {
    return this.contentData.title || ''
  }

  get publishDate(): string {
    const publishDate = this.toMoment(this.contentData.publishedDate)
    const displayDate = this.isEffectiveDate(publishDate) ? publishDate : undefined
    return displayDate ? displayDate.format('YYYY-MM-DD HH:mm') : 'ここには記事の公開日時が表示されます'
  }

  get setPublishDate(): string {
    if (this.previewContentType === 'external') {
      return `<es:content_detail_publish_date>1800-01-01 00:00</es:content_detail_publish_date>`
    }
    if (this.previewContentType === 'internal') {
      return this.publishDate
    }
    throw new Error('プレビューで生成するコンテンツの種類以外が入力されました。')
  }

  toMoment(date: string | undefined): Moment | undefined {
    if (!date) {
      return undefined
    }
    return moment(date)
  }

  isEffectiveDate(date: Moment | undefined): boolean {
    return !!date && date.get('year') > 1900
  }
}
